export default {"src":"/_next/static/media/briefcase.1f55480a.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};